import * as ActionTypes from '../actions/actionTypes'
//@ts-ignore
import objectPath from 'object-path'

export default function reduce(state = {}, action: any) {
	let stateLocation, value, newState;
	switch(action.type) {
		case ActionTypes.SET_GENERATE_NEW_SESSION_FLAG:
		    newState = Object.assign({}, state);
		    objectPath.set(newState, action.payload.stateLocation, action.payload.value);
		    return newState;

		case ActionTypes.SET_STATE_FOR_NEW_SESSION:
			stateLocation = action.payload.stateLocation;
			value = action.payload.value;

			let stateCopy = Object.assign({}, state);

			objectPath.set(stateCopy, stateLocation, value);

			return stateCopy;

		case ActionTypes.SET_RESET_FUNCTION_FLAG:
		    newState = Object.assign({}, state);
		    objectPath.set(newState, action.payload.stateLocation, action.payload.value);
		    return newState;

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./modules/generate-new-session/reducers/index.ts